var account = "Hesap";
var accountSettings = "Hesap Ayarları";
var charging = "Şarj";
var contactInfo = "İletişim Bilgileri";
var dashboard = "Gösterge Paneli";
var home = "Ev";
var myProducts = "Ürünlerim";
var orderHistory = "Sipariş Geçmişi";
var paymentMethod = "Ödeme Yöntemi";
var profileSettings = "Profil Ayarları";
var referAndEarn = "Tavsiye Edin ve Kazanın";
var signOut = "Oturumu Kapat";
var tr_TR = {
	account: account,
	accountSettings: accountSettings,
	charging: charging,
	contactInfo: contactInfo,
	dashboard: dashboard,
	home: home,
	myProducts: myProducts,
	orderHistory: orderHistory,
	paymentMethod: paymentMethod,
	profileSettings: profileSettings,
	referAndEarn: referAndEarn,
	signOut: signOut
};

export { account, accountSettings, charging, contactInfo, dashboard, tr_TR as default, home, myProducts, orderHistory, paymentMethod, profileSettings, referAndEarn, signOut };
